export default __webpack_public_path__ + "f60b96e745fa892b184774a832f79501.jpg";